import { useCallback } from 'react';

export const useExpandCollapseAllState = (
  key: string
): {
  expandAllState: boolean;
  setExpandCollapseState: (state: boolean) => void;
} => {
  const expandAllState = sessionStorage.getItem(key)
    ? sessionStorage.getItem(key) === 'true'
    : true;

  const setExpandCollapseState = useCallback(
    (newState: boolean) => {
      sessionStorage.setItem(key, newState ? 'true' : 'false');
    },
    [key]
  );

  return {
    expandAllState,
    setExpandCollapseState
  };
};

export default useExpandCollapseAllState;
